export class LoadingEnd {
    public static readonly type = '[RootState] End loading';
}
